import React from 'react'
import { colors } from '../../theme'

function Clear() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill={colors.grey900}
        d="M17.91 2.182a.5.5 0 010 .707L12.587 8.21a4.5 4.5 0 01-.334 5.991l-.664.664-2.09 3.483a.5.5 0 01-.781.096l-7.072-7.071a.5.5 0 01.097-.782l3.482-2.09.664-.664a4.5 4.5 0 015.991-.334l5.323-5.322a.5.5 0 01.707 0zM6.243 8.899l4.95 4.95.353-.354a3.5 3.5 0 10-4.95-4.95l-.353.354zm-.785.63l-2.652 1.59 6.166 6.166 1.59-2.652L5.459 9.53z"
      />
    </svg>
  )
}

export default Clear
